module.exports = __webpack_public_path__ + "img/start-event.e895cee2.svg";